var React = require('react');

function FooterHeartIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M50 17.7C36.883-4.808 0 1.763 0 29.967c0 19.42 23.213 39.279 50 65.866 26.792-26.587 50-46.445 50-65.866 0-28.3-36.98-34.609-50-12.267z","fill":"#ff7dd3","fillRule":"nonzero"}));
}

FooterHeartIcon.defaultProps = {"width":"15","height":"15","viewBox":"0 0 100 100","fillRule":"evenodd","clipRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2"};

module.exports = FooterHeartIcon;

FooterHeartIcon.default = FooterHeartIcon;
